import React from 'react';
import Time from 'react-time';

//Icon for heart beat
import HeartSyncIcon from '@material-ui/icons/Sync';
import HeartSyncProblemIcon from '@material-ui/icons/SyncDisabled';
import HeartSyncUpdateIcon from '@material-ui/icons/SyncProblem';

//import AppStore from '../../stores/app-store';

const dateFormat = 'YYYY-MM-DD HH:mm';

/* Time constant in seconds */
const SECOND = 1;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
/**
 * UI helper implementation
 */
export function getColumnHeaders(type) {
  switch(type) {
  case 'authorized':
    return _getAuthorizedColumnHeader();
  case 'pending':
    return _getPendingColumnHeader();
  case 'preauthorize':
    return _getPreAuthorizeColumnHeader();
  case 'rejected':
    return _getRejectedColumnHeader();
  default:
    return [];
  }
}
/* eslint-disable */
function _getAuthorizedColumnHeader() {
  return ([
    {
      id: 1,
      title:'UUID',
      name: 'UUID',
      isSortable: true,
      style: { flexGrow: 1, maxWidth: 260 },
      filterLabel: 'Filter By UUID',
      filter: '',
      filterMaxWidth: 260,
      render: device => (device.identity_data ? device.identity_data.UUID : '-')
    },
    {
      id: 2,
      title: 'Device Type',
      name: 'device_type',
      style: { maxWidth: 170 },
      filterLabel: 'Filter By Type',
      filter: '',
      filterMaxWidth: 170,
      render: device => {
        const found = (device.attributes || []).find(item => item.name === 'device_type');
        return found ? found.value : '-';
      }
    },
    {
      id: 3,
      title: 'Device Mode',
      name: 'device_mode',
      style: { maxWidth: 220 },
      filterLabel: 'Filter By Mode',
      filter: '',
      filterMaxWidth: 220,
      render: device => (
        device.type && device.config_name  && device.flavor_name
          ? device.type + '/' + device.flavor_name + '/' + device.config_name
          : '-'
      )
    },
    {
      id: 4,
      title: 'Label',
      name: 'comment',
      style: { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: 140 },
      filterLabel: 'Filter By Label',
      filter: '',
      filterMaxWidth: 140,
      render: device => (device.label ? device.label : '-')
    },
    {
      id: 5,
      title: 'Current Software',
      name: 'current_software',
      style: { maxWidth: 160 },
      filterLabel: 'Filter By Software',
      filter: '',
      filterMaxWidth: 160,
      render: device => {
        const found = (device.attributes || []).find(item => item.name === 'artifact_name');
        return found ? found.value : '-';
      }
    },
    {
      id: 6,
      title: 'Last Heartbeat',
      name: 'last_checkin',
      isSortable: true,
      property: 'updated_ts',
      style: { maxWidth: 195 },
      filterLabel: 'Filter By Heartbeat',
      filter: '',
      filterMaxWidth: 195,
      render: device => {
        // Icon for Heartbeat
        let curTime = new Date();
        let device_updated_ts = new Date(device.updated_ts);
        let time_minutes = Math.floor((curTime - device_updated_ts) / 60000);
        let time_seconds = time_minutes*60;
        const iconStyle = { marginRight: '2px', height: '15px', verticalAlign: 'bottom' };
        let heartIcon =
          (time_seconds <= (MINUTE) ? <HeartSyncIcon style={Object.assign({ color: 'green' }, iconStyle)} />
            : time_seconds <= (5 * MINUTE) ? <HeartSyncUpdateIcon style={Object.assign({ color: 'yellow' }, iconStyle)} />
              : time_seconds <= (DAY)  ? <HeartSyncProblemIcon style={Object.assign({ color: 'orange' }, iconStyle)} />
                : <HeartSyncProblemIcon style={Object.assign({ color: 'red' }, iconStyle)} />);

        return (device.updated_ts ? <div> { heartIcon } <Time value={device.updated_ts} format={dateFormat} /> </div> : '-')
      }
    }
  ]);
}

function _getPendingColumnHeader() {
  return([
    {
      title:'UUID',
      name: 'UUID',
      isSetting: true,
      style: { flexGrow: 1, width: '40%' },
      render: device => (device.identity_data ? device.identity_data.UUID : '-')
    },
    {
      title: 'First request',
      name: 'first_request',
      style: { width: '20%' },
      property: 'created_ts',
      render: device => (device.created_ts ? <Time value={device.created_ts} format={dateFormat} /> : '-')
    },
    {
      title: 'Last checkin',
      name: 'last_checkin',
      property: 'updated_ts',
      style: { width: '20%' },
      render: device => (device.updated_ts ? <Time value={device.updated_ts} format={dateFormat} /> : '-')
    },
    {
      title: 'Status',
      name: 'status',
      property: 'status',
      style: { width: '20%' },
      render: device => (device.status ? <div className="capitalized">{device.status}</div> : '-')
    }
  ]);
}

function _getPreAuthorizeColumnHeader() {
  return([
    {
      title: 'UUID',
      name: 'UUID',
      isSetting: true,
      style: { flexGrow: 1, width: '50%' },
      render: device => (device.identity_data ? device.identity_data.UUID : '-')
    },
    {
      title: 'Date added',
      name: 'date_added',
      property: 'created_ts',
      style: { width: '25%' },
      render: device => (device.created_ts ? <Time value={device.created_ts} format={dateFormat} /> : '-')
    },
    {
      title: 'Status',
      name: 'status',
      property: 'status',
      style: { width: '25%' },
      render: device => (device.status ? <div className="capitalized">{device.status}</div> : '-')
    }
  ]);
}

function _getRejectedColumnHeader() {
  return([
    {
      title: 'UUID',
      name: 'device_id',
      isSetting: true,
      style: { flexGrow: 1, width: '40%' },
      render: device => (device.identity_data ? device.identity_data.UUID : '-')
    },
    {
      title: 'First request',
      name: 'first_request',
      property: 'created_ts',
      style: { width: '20%' },
      render: device => (device.created_ts ? <Time value={device.created_ts} format={dateFormat} /> : '-')
    },
    {
      title: 'Last checkin',
      name: 'last_checkin',
      property: 'updated_ts',
      style: { width: '20%' },
      render: device => (device.updated_ts ? <Time value={device.updated_ts} format={dateFormat} /> : '-')
    },
    {
      title: 'Status',
      name: 'status',
      property: 'status',
      style: { width: '20%' },
      render: device => (device.status ? <div className="capitalized">{device.status}</div> : '-')
    }
  ]);
}
/* eslint-enable */
